import { Button, ButtonProps } from "@mui/material";
import React from "react";

const AppButton = ({ children, disableElevation, variant, ...other }: { children: React.ReactNode } & ButtonProps) => <Button sx={{
    textTransform: "none",
    borderRadius: "1rem"
}} disableElevation variant="contained" {...other}>
    {children}
</Button>
export default AppButton;